import { useTranslation } from 'next-i18next';

import { Link, Scrollbar } from '@components/ui';
import { isArrayEmpty } from '@helpers/ArrayHelpers';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { useSearchSuggestions } from '@hooks/data/useSearchSuggestions';

import styles from './SearchPageSuggestedCategories.module.scss';

interface Props {
  keyword: string
}

const SearchPageSuggestedCategories = (props: Props) => {
  const { keyword } = props;
  const { data: categoriesData } = useSearchSuggestions(keyword);

  const { t } = useTranslation();
  const isBreakpoint = useMediaQuery(`(min-width: ${styles.breakpoint})`);

  if (isArrayEmpty(categoriesData?.categories) || !isBreakpoint) {
    return null;
  }

  const { categories } = categoriesData;

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        {t('SEARCH.SUGGESTED_CATEGORIES_TITLE')}
      </div>
      <Scrollbar
        className={styles.scrollbar}
        autoHide={false}
        forceVisible="y"
      >
        <ul className={styles.categories}>
          {categories?.map((category, index) => {
            const {
              code, name, url
            } = category;
            return (
              <li className={styles.category} key={`${code}-${index}`}>
                <Link passHref href={url} prefetch={false}>
                  <a>{name}</a>
                </Link>
              </li>
            );
          })}
        </ul>
      </Scrollbar>
    </div>
  );
};

export default SearchPageSuggestedCategories;
